import ls from 'local-storage'
export default {
  getLocation: (state, getters) => (locationId) => {
    switch (locationId) {
      case 1: {
        return {
          id: 1,
          name: 'Liverpool Street',
          postcode: 'EC2'
        }
      }
      case 2: {
        return {
          id: 1,
          name: 'Clerkenwell',
          postcode: 'EC1'
        }
      }
    }
  },
  getCartTotal: (state, getters) => {
    const cart = state.cart

    let total = 0

    cart.forEach((row) => {
      total = total + ((row.discount > 0 ? row.discount : row.price) * row.quantity)
    })

    return total
  },
  getOrderType: (state, getters) => {
    let orderType = ls.get('orderType')
    if (orderType && state.websiteAvailability.canDoDelivery === true) {
      return orderType
    }
    return 'collection'
  },
  infoPopupOpened: (state, getters) => {
    const popupOpened = ls.get('infoPopupOpened')

    if (popupOpened !== null) {
      return popupOpened
    }

    return true
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js